import { Table, TableHead, TableRow, TableBody, TableCell, Link } from '@mui/material'

interface IGoogleAdGroup {
  readonly name: string
}

interface IGoogleAdItem {
  readonly id: string
  readonly name: string | null
  readonly status: string | null
  readonly adType: string | null
  readonly headline: string | null
  readonly finalUrl: string | null
  readonly impressions: number | null
  readonly clicks: number | null
  readonly ctr: number | null
  readonly conversions: number | null
  readonly adGroup: IGoogleAdGroup | null
}

interface IGoogleAnalyticsTable {
  readonly adsData: IGoogleAdItem[]
}

// Spend figures (cost, average CPC) are imported and stored but deliberately NOT shown
// here — this view is performance-only.

const formatNumber = (value: number | null) =>
  value === null || value === undefined ? 'N/A' : value.toLocaleString()

const GoogleAnalyticsTable = ({ adsData }: IGoogleAnalyticsTable) => (
  <Table
    sx={{
      '& .MuiTableCell-root': {
        paddingLeft: 0,
      },
    }}
  >
    <TableHead>
      <TableRow>
        <TableCell>Ad</TableCell>
        <TableCell>Ad Group</TableCell>
        <TableCell>Clicks</TableCell>
        <TableCell>Impressions</TableCell>
        <TableCell>CTR</TableCell>
        <TableCell>Conversions</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {adsData.map((ad) => (
        <TableRow key={ad.id}>
          <TableCell>
            {/* Google gives no creative image for search ads, so the headline is the only
                human-readable identifier. Link out to the landing page when we have one. */}
            {ad.finalUrl ? (
              <Link href={ad.finalUrl} target="_blank" rel="noopener noreferrer" underline="hover">
                {ad.headline || ad.name || 'Ad'}
              </Link>
            ) : (
              ad.headline || ad.name || 'Ad'
            )}
          </TableCell>
          <TableCell>{ad.adGroup?.name ?? 'N/A'}</TableCell>
          <TableCell>{formatNumber(ad.clicks)}</TableCell>
          <TableCell>{formatNumber(ad.impressions)}</TableCell>
          <TableCell>
            {ad.ctr === null || ad.ctr === undefined
              ? 'N/A'
              : `${Number(ad.ctr).toFixed(2).replace('.', ',')}%`}
          </TableCell>
          <TableCell>
            {ad.conversions === null || ad.conversions === undefined
              ? 'N/A'
              : Number(ad.conversions).toFixed(2).replace('.', ',')}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
)

export default GoogleAnalyticsTable
